













































































import "./invite-modal.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import UserAvatar from "../../components/common/user-avatar.vue";
import Ajax from "../../lib/ajax";

export default Vue.extend({
  name: "AddPriority",
  components: { UserAvatar },
  props: {
    member: Object,
    show: Boolean,
  },
  data() {
    return {
      selectedUser: null,
      users: [],
      userResult: [],
      sending: false,
      hashTagFilter: "All",
      selectedGoalId: null,
      selectedProjectId: null,
      selectedReviewId: null,
      selectedTeamId: null,
      priorityModel: {
        type: "team",
        role: null,
      },
      rules: {
        role: [
          {
            required: true,
            message: "Please choose a role",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("billing", ["billingAccount"]),
    ...mapGetters("billing", ["currentBillingAccountInviteRoles"]),
    ...mapState("team", ["myTeams"]),
    ...mapGetters("team", ["currentTeamInviteRoles"]),
    ...mapState("goal", ["myTrackingGoals"]),
    ...mapGetters("goal", ["currentGoalInviteRoles"]),
    ...mapState("review", ["myTrackingReviews"]),
    ...mapGetters("review", ["currentReviewInviteRoles"]),
    ...mapState("project", ["myProjects"]),
    ...mapGetters("project", ["currentProjectInviteRoles"]),
    showModal: {
      get: function () {
        return (this as any).show;
      },
      set: function (newValue) {
        (this as any).$emit("cancel");
      },
    },
    goalOptions(): any {
      let allGoals = this.$store.state.goal.myTrackingGoals || [];
      if (this.hashTagFilter !== "All") {
        allGoals = allGoals.filter((goal) => goal.hashTagList && goal.hashTagList.filter((tag) => tag.text === this.hashTagFilter).length > 0);
      }

      return allGoals;
    },
    selectedGoal(): any {
      let goals = this.goalOptions.filter((goal) => goal.id === this.selectedGoalId);
      return goals.length === 1 ? goals[0] : null;
    },
    reviewOptions(): any {
      let allReviews = this.$store.state.review.myTrackingReviews || [];
      if (this.hashTagFilter !== "All") {
        allReviews = allReviews.filter((review) => review.hashTagList && review.hashTagList.filter((tag) => tag.text === this.hashTagFilter).length > 0);
      }

      return allReviews;
    },
    selectedReview(): any {
      let reviews = this.reviewOptions.filter((review) => review.id === this.selectedReviewId);
      return reviews.length === 1 ? reviews[0] : null;
    },
    teamOptions(): any {
      let allTeams = this.$store.state.team.myTeams || [];
      if (this.hashTagFilter !== "All") {
        allTeams = allTeams.filter((team) => team.hashTagList && team.hashTagList.filter((tag) => tag.text === this.hashTagFilter).length > 0);
      }

      return allTeams;
    },
    selectedTeam(): any {
      let teams = this.teamOptions.filter((team) => team.id === this.selectedTeamId);
      return teams.length === 1 ? teams[0] : null;
    },
    projectOptions(): any {
      let allProjects = this.$store.state.project.myProjects || [];
      if (this.hashTagFilter !== "All") {
        allProjects = allProjects.filter((project) => project.hashTagList && project.hashTagList.filter((tag) => tag.text === this.hashTagFilter).length > 0);
      }

      return allProjects;
    },
    selectedProject(): any {
      let projects = this.projectOptions.filter((project) => project.id === this.selectedProjectId);
      return projects.length === 1 ? projects[0] : null;
    },
    hashTagOptions() {
      let hashTags = ["All"];
      if (this.priorityModel.type === "goal") {
        let allGoals = this.$store.state.goal.myTrackingGoals || [];
        allGoals.forEach((goal) => {
          hashTags = hashTags.concat(goal.hashTagList.map((tag) => tag.text));
        });
      } else if (this.priorityModel.type === "review") {
        let allReviews = this.$store.state.review.myTrackingReviews || [];
        allReviews.forEach((review) => {
          hashTags = hashTags.concat(review.hashTagList.map((tag) => tag.text));
        });
      } else if (this.priorityModel.type === "team") {
        let allTeams = this.$store.state.team.myTeams || [];
        allTeams.forEach((team) => {
          hashTags = hashTags.concat(team.hashTagList.map((tag) => tag.text));
        });
      } else {
        let allProjects = this.$store.state.project.myProjects || [];
        allProjects.forEach((project) => {
          hashTags = hashTags.concat(project.hashTagList.map((tag) => tag.text));
        });
      }
      return [...new Set(hashTags)];
    },
  },
  watch: {
    showModal(newVal) {
      if (newVal === true) {
        this.priorityModel.role = null;
      }
    },
  },
  created() {
    this.$store.dispatch("goal/getMyTrackingGoals").then(() => {});
    this.$store.dispatch("review/getMyReviews", {}).then(() => {});
    this.$store.dispatch("team/getMyTeams", {}).then(() => {});
    this.$store.dispatch("project/getMyProjects", {}).then(() => {});
  },
  methods: {
    handleAddPriority() {
      let context = this as any;
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;
      context.sending = true;

      (context.$refs["AddPriorityForm"] as any).validate((valid) => {
        if (valid) {
          if (context.priorityModel.type === "goal") {
            this.$store
              .dispatch("goal/inviteMember", {
                data: {
                  memberId: context.member.memberId,
                  role: context.priorityModel.role,
                  goalId: context.selectedGoalId,
                },
              })
              .then((response) => {
                context.$emit("reload-priorities");
              })
              .finally(() => {
                context.sending = false;
                target.disabled = false;
              });
          } else if (context.priorityModel.type === "project") {
            this.$store
              .dispatch("project/inviteMember", {
                data: {
                  memberId: context.member.memberId,
                  role: context.priorityModel.role,
                  beOwner: false,
                  projectId: context.selectedProjectId,
                },
              })
              .then((response) => {
                context.$emit("reload-priorities");
              })
              .finally(() => {
                context.sending = false;
                target.disabled = false;
              });
          } else if (context.priorityModel.type === "review") {
            this.$store
              .dispatch("review/inviteMember", {
                data: {
                  memberId: context.member.memberId,
                  role: context.priorityModel.role,
                  reviewId: context.selectedReviewId,
                },
              })
              .then((response) => {
                context.$emit("reload-priorities");
              })
              .finally(() => {
                context.sending = false;
                target.disabled = false;
              });
          } else if (context.priorityModel.type === "team") {
            this.$store
              .dispatch("team/inviteMember", {
                data: {
                  memberId: context.member.memberId,
                  role: context.priorityModel.role,
                  teamId: context.selectedTeamId,
                },
              })
              .then((response) => {
                context.$emit("reload-priorities");
              })
              .finally(() => {
                context.sending = false;
                target.disabled = false;
              });
          }
        } else {
          context.sending = false;
          target.disabled = false;
          return;
        }
      });
    },
  },
});
